export const MAINPAGE_ROUTE = "/";
export const ABOUTUS_ROUTE = "/aboutus";
export const MEMBERSHIP_ROUTE = "/membership";
export const FAQ_ROUTE = "/faq";
export const ERROR_PAGE = '/error';